import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const WidgetSize = (props) => {
    const cells = useMemo(
        () => [
            {
                value: '1-1',
            },
            {
                value: '2-1',
            },
        ],
        [],
    );

    const changeSize = (value) => {
        const { onChange = () => null, input } = props;

        input.onChange(value);
        onChange(value);
    };

    const renderCells = cells.map((cell) => (
        <button
            key={cell.value}
            type="button"
            onClick={() => changeSize(cell.value)}
            className={`widget-size__cell widget-size__cell--${cell.value}
        ${props.value === cell.value ? 'selected' : ''}
      `}
        >
            {cell.value}
        </button>
    ));

    return <div className="widget-size">{renderCells}</div>;
};

WidgetSize.propTypes = {
    input: PropTypes.shape({}).isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func,
};

export default WidgetSize;
